import apiClient from '../apiClient';

export const getAllApprovedModels = () => {
    return apiClient.get('/admin/approved-models');
};

export const getApprovedModelById = (id) => {
    return apiClient.get(`/admin/approved-models/${id}`);
};

export const createApprovedModel = (data) => {
    return apiClient.post('/admin/approved-models', data);
};

export const updateApprovedModel = (id, data) => {
    return apiClient.put(`/admin/approved-models/${id}`, data);
};

export const deactivateApprovedModel = (id) => {
    return apiClient.post(`/admin/approved-models/${id}/deactivate`);
};

export const deprecateApprovedModel = (id) => {
    return apiClient.post(`/admin/approved-models/${id}/deprecate`);
};

export const deleteApprovedModel = (id) => {
    return apiClient.delete(`/admin/approved-models/${id}`);
};

export const getModelUsage = (id) => {
    return apiClient.get(`/admin/approved-models/${id}/usage`);
};

export const getAvailableBedrockModels = () => {
    return apiClient.get('/admin/approved-models/bedrock/available');
};

export const detectModelCapabilities = (id) => {
    return apiClient.post(`/admin/approved-models/${id}/detect-capabilities`);
};
